module.exports = __webpack_public_path__ + "img/17.DoveSensitiveSkinSoap.4d76eeb5.png";